import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import {CookiesConsentService} from '../../_services/cookies-consent.service';
import {AppService} from '../../_services/app.service';
import {MedalliaService} from '../../_services/medallia.service';

@Component({
  selector: 'cookies-consent',
  templateUrl: './cookies-consent.component.html',
  styleUrls: ['./cookies-consent.component.scss']
})
export class CookiesConsentComponent {
  @ViewChild('cookiesSettings') cookiesSettings: ModalDirective;
  isCookiesOptionsOpened = false
  required: boolean = true;
  analytics: boolean = false;
  thirdParty: boolean = false;
  @Input() isVisible: boolean;
  @Output() accept: EventEmitter<void> = new EventEmitter();

  constructor(
    private cookiesConsentService: CookiesConsentService,
    private appService: AppService,
    private medalliaService: MedalliaService,
  ) {}

  postSettings() {
    this.cookiesSettings.hide()
    this.accept.emit();
    const user = this.appService.UsuarioLogado;
    this.cookiesConsentService.postCookiesSettings({
      consentVersion: "v1",
      customerEmail: user.email,
      customerId: user.usuarioID,
      optIn: this.analytics && this.thirdParty,
      // ipAddress: "",
      cookieChoices: {
        analytics: this.analytics,
        necessary: true,
        thirdParty: this.thirdParty,
      },
      webAddress: 'https://portalcabotagem.com.br',
    }).subscribe(() => {
      this.cookiesConsentService.getDataByUserId(user.usuarioID, user.email).subscribe(value => {
        this.medalliaService.updateOptInValue(value.optIn)
      })
    })
  }

  openCookiesSettings () {
    this.isCookiesOptionsOpened = true
    this.cookiesSettings.show()
  }

  closeCookiesSettings () {
    this.analytics = false;
    this.thirdParty = false;
    this.isCookiesOptionsOpened = false
    this.cookiesSettings.hide()
  }

  acceptAllCookies() {
    this.analytics = true;
    this.thirdParty = true;
    this.accept.emit();
    this.postSettings();
  }
}
